import { TokenBalanceParams, TokenBalanceResponse, TokenBalanceItem } from '@/types/tokenBalance';

// 获取代币余额
export async function getTokenBalance(params: TokenBalanceParams): Promise<TokenBalanceResponse> {
  try {
    // 构建查询参数
    const searchParams = new URLSearchParams({
      chainShortName: params.chainShortName,
      address: params.address,
      protocolType: params.protocolType,
    });

    if (params.tokenContractAddress) {
      searchParams.append('tokenContractAddress', params.tokenContractAddress);
    }
    if (params.page) {
      searchParams.append('page', params.page);
    }
    if (params.limit) {
      searchParams.append('limit', params.limit);
    }

    // 调用本地API路由
    const response = await fetch(`https://web-production-3c3c.up.railway.app/api/xgenswap-v3/okx/address/token-balance?${searchParams.toString()}`);
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const data: TokenBalanceResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch token balance:', error);
    throw error;
  }
}

// 获取所有页的代币余额数据
export async function getAllTokenBalancePages(
  address: string,
  chainShortName: string = 'XLAYER',
  protocolType: 'token_20' | 'token_721' | 'token_1155' = 'token_20',
  limit: string = '50'
): Promise<TokenBalanceItem[]> {
  try {
    let allTokens: TokenBalanceItem[] = [];
    let page = 1;
    let hasMorePages = true;

    while (hasMorePages) {
      const response = await getTokenBalance({
        chainShortName,
        address,
        protocolType,
        page: page.toString(),
        limit,
      });

      if (response.code === '0' && response.data && response.data.length > 0) {
        const pageData = response.data[0]; // 取第一页数据
        if (pageData.tokenList && pageData.tokenList.length > 0) {
          allTokens = [...allTokens, ...pageData.tokenList];
        }

        // 检查是否还有更多页
        const totalPage = parseInt(pageData.totalPage || '1');
        if (page >= totalPage) {
          hasMorePages = false;
        } else {
          page++;
        }
      } else {
        hasMorePages = false;
      }
    }

    return allTokens;
  } catch (error) {
    console.error('Failed to fetch all token balance pages:', error);
    throw error;
  }
}

// 获取ERC-20代币余额
export async function getERC20TokenBalance(
  address: string, 
  chainShortName: string = 'XLAYER',
  page?: string,
  limit?: string
): Promise<TokenBalanceResponse> {
  return getTokenBalance({
    chainShortName,
    address,
    protocolType: 'token_20',
    page,
    limit,
  });
}

// 获取所有ERC-20代币余额
export async function getAllERC20TokenBalance(
  address: string,
  chainShortName: string = 'XLAYER'
): Promise<TokenBalanceItem[]> {
  return getAllTokenBalancePages(address, chainShortName, 'token_20');
}

// 获取ERC-721代币余额
export async function getERC721TokenBalance(
  address: string, 
  chainShortName: string = 'XLAYER',
  page?: string,
  limit?: string
): Promise<TokenBalanceResponse> {
  return getTokenBalance({
    chainShortName,
    address,
    protocolType: 'token_721',
    page,
    limit,
  });
}

// 获取ERC-1155代币余额
export async function getERC1155TokenBalance(
  address: string, 
  chainShortName: string = 'XLAYER',
  page?: string,
  limit?: string
): Promise<TokenBalanceResponse> {
  return getTokenBalance({
    chainShortName,
    address,
    protocolType: 'token_1155',
    page,
    limit,
  });
}

// 获取特定代币合约的余额
export async function getSpecificTokenBalance(
  address: string,
  tokenContractAddress: string,
  chainShortName: string = 'XLAYER'
): Promise<TokenBalanceResponse> {
  return getTokenBalance({
    chainShortName,
    address,
    protocolType: 'token_20',
    tokenContractAddress,
  });
}

// 获取原生OKB余额（通过查询WOKB合约）
export async function getNativeOKBBalance(
  address: string,
): Promise<string> {
  try {
    // 使用现有的API获取原生OKB余额
    // const baseUrl = process.env.NODE_ENV === 'development' 
    //   ? 'http://localhost:3000' 
    //   : 'https://your-production-domain.com';
    
    // const response = await fetch(`${baseUrl}/api/v2/addresses/${address}`);
    // if (!response.ok) {
    //   console.warn('Failed to fetch native OKB balance, using default value');
    //   return '0';
    // }
    console.log('address', address);
    
    // const data = await response.json();
    return  '0';
  } catch (error) {
    console.warn('Error fetching native OKB balance:', error);
    return '0';
  }
} 